import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, ITrainingGroup, ITrainingGroupUpsert } from '../../interfaces'

const getAddTrainingGroupMutationRequest: IGetPostRequest = params => {
  return {
    method: 'post',
    url: `${config.baseUrl}/TrainingGroups`,
  }
}

const useAddTrainingGroupMutation: IUseAddMutation<ITrainingGroup, ITrainingGroupUpsert> = (params, options = {}) => {
  const request = useMemo(() => getAddTrainingGroupMutationRequest(params), [params])

  const addTraining: IAddFn<ITrainingGroupUpsert, ITrainingGroup> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingGroup, Error, any>({
    mutationFn: addTraining,
    ...options,
  })

  return response
}

export default useAddTrainingGroupMutation
